export default __webpack_public_path__ + "static/colibri-8-web-de7d17726b181be927272503e3041bda.pdf";